// extracted by mini-css-extract-plugin
module.exports = {"sticky":"_2znMM","stickyContent":"_1Fk2k","name":"_1yyJD","logo":"Y_vTQ","logoImage":"_2dP4r"};